module.exports = __webpack_public_path__ + "img/jzxz.a09c471d.png";